import React, { useState } from "react";
import Sebastian from "../../assets/images/Sebastian.jpg";
import Julian from "../../assets/images/Julian.jpeg"
import LBlogo from "../../assets/images/LB_logo.jpeg"
import DHLogo from "../../assets/images/DHLogo.webp"

export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote:
        "Die Zusammenarbeit mit Bollwerk X war eine der besten Entscheidungen für unser Unternehmen. Sie haben nicht nur Schwachstellen gefunden, die wir nie erkannt hätten, sondern auch maßgeschneiderte Lösungen entwickelt, die perfekt zu unseren Anforderungen passen. Ihre Kombination aus technischer Exzellenz und verständlicher Beratung macht sie zu einem unschlagbaren Partner!",
      author: "Sebastian Lenders",
      position: "CEO, Lenders Beratung",
      avatar: Sebastian,
      companyLogo: LBlogo,
      rating: 5,
    },
    {
      quote:
        "Seit wir mit Bollwerk X zusammenarbeiten, fühlen wir uns endlich sicher vor Cyberbedrohungen. Ihr proaktiver Ansatz, gepaart mit ihrer tiefgehenden Expertise, hat unsere IT-Sicherheit auf ein völlig neues Level gehoben. Das Team ist jederzeit erreichbar, handelt blitzschnell und denkt immer einen Schritt voraus – echte Profis!  ",
      author: "Julian Stechert",
      position: "CEO, Deutsche Hörakustik",
      avatar: Julian,
      companyLogo:
        DHLogo ,
      rating: 4,
    },
  ];

  return (
    <section className="bg-white py-20 px-4 md:px-16">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          {/* Testimonial Slider */}
          <div className="relative">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`flex flex-col items-center ${
                  index === currentIndex ? "block" : "hidden"
                }`}
              >
                {/* Star Rating */}
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <img
                      key={i}
                      src={
                        i < testimonial.rating
                          ? "https://cdn.builder.io/api/v1/image/assets/050e9e06a4ba427180c95aafad933265/7e4df2cd1a7939a31855fa8e82b1b9421fc9a6af4643291313cbb9984d060bb0"
                          : "https://cdn.builder.io/api/v1/image/assets/050e9e06a4ba427180c95aafad933265/83f3e69b86bf8ad599b9ef8530cabb2e2ef9cd8b64327ff462cd47fb16eccadd"
                      }
                      className="w-5 h-5"
                      alt={`${i < testimonial.rating ? "Filled star" : "Empty star"}`}
                    />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="mt-8 text-2xl font-bold leading-[1.4] text-black">
                  "{testimonial.quote}"
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center gap-5 mt-8">
                  <img
                    src={testimonial.avatar}
                    className="w-14 h-14 rounded-full object-cover"
                    alt={testimonial.author}
                  />
                  <div className="text-left">
                    <div className="font-semibold text-black">{testimonial.author}</div>
                    <div className="text-gray-600">{testimonial.position}</div>
                  </div>
                  <div className="h-[61px] w-px bg-black mx-5" />
                  <img
                    src={testimonial.companyLogo}
                    className="h-15 object-contain"
                    alt="Company logo"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Dots */}
          <div className="flex justify-center gap-2 mt-12">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full ${
                  index === currentIndex ? "bg-black" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
